import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	WithStyles,
} from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import i18n from '../resources/i18n';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { ISearchOrgUserItem } from 'src/actions/quickModeOrgUserRegisterIniUser';
import { IRootState } from '../reducers';

const styles = (theme: Theme) =>
	createStyles({
		listItem: {
			borderRadius: '12px',
			height: '50px',
			paddingLeft: '5px',
		},
		listItemText: {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			width: '100%',
		},
		root: {
			margin: '0 auto',
			padding: 0,
			wordBreak: 'break-all',
		},
		tabelCellColorFont: {
			color: '#000000',
			fontSize: '13px',
			fontWeight: 'bold',
		},
		tabelCellWidth: {
			minWidth: '200px',
			width: '16%',
		},
		tableDiv: {
			overflowX: 'auto',
		},
	});

interface IState {
	openOrg: boolean;
	width: number;
}

/**
 * QuickModeOrgUserRegisterTreeDetail
 */
class QuickModeOrgUserRegisterTreeDetail extends React.Component<
	IProps,
	IState
> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			openOrg: true,
			width: 200,
		};
		this.toggleTree = this.toggleTree.bind(this);
		this.handleResize = this.handleResize.bind(this);
	}

	public render() {
		const { classes, searchOrgUserItemArry } = this.props;
		const { level, orgName, userList, children } = searchOrgUserItemArry;
		let width = this.state.width;
		if (this.props.width) {
			width = this.props.width;
		}
		return (
			<div className={classes.root}>
				<List
					component="nav"
					style={{
						paddingBottom: 0,
					}}
				>
					<ListItem
						button={true}
						onClick={this.toggleTree}
						className={this.props.classes.listItem}
						style={{
							backgroundColor: '#CDE3ED',
							marginLeft: level === 1 ? 0 : 40 * level,
							width:
								level === 1
									? this.state.width
									: width - 40 * level,
						}}
					>
						{userList &&
						children &&
						(userList.length !== 0 || children.length !== 0) &&
						this.state.openOrg ? (
							<ExpandMore />
						) : (
							<ChevronRight />
						)}
						<ListItemText
							inset={true}
							primary={orgName}
							style={{ paddingLeft: '10px' }}
							className={classes.listItemText}
						/>
					</ListItem>
					<div className={classes.tableDiv}>
						{userList &&
						userList.length !== 0 &&
						this.state.openOrg ? (
							<Table
								style={{
									marginTop: 8,
									minWidth: 1200,
									width,
								}}
							>
								<TableHead>
									<TableRow
										style={{
											borderBottom: '1px #d9d9d9 solid',
											borderTop: '1px #d9d9d9 solid',
										}}
									>
										<TableCell
											className={
												this.props.classes
													.tabelCellColorFont
											}
										>
											{i18n.t(
												'QUICKMODE_ORGUSERREGISTER_LOGINID'
											)}
										</TableCell>
										<TableCell
											className={
												this.props.classes
													.tabelCellColorFont
											}
										>
											{i18n.t(
												'QUICKMODE_ORGUSERREGISTER_FAMILYNAME'
											)}
										</TableCell>
										<TableCell
											className={
												this.props.classes
													.tabelCellColorFont
											}
										>
											{i18n.t(
												'QUICKMODE_ORGUSERREGISTER_FIRSTNAME'
											)}
										</TableCell>
										<TableCell
											className={
												this.props.classes
													.tabelCellColorFont
											}
										>
											{i18n.t(
												'QUICKMODE_ORGUSERREGISTER_MAILADDRESS'
											)}
										</TableCell>
										<TableCell
											className={
												this.props.classes
													.tabelCellColorFont
											}
										>
											{i18n.t(
												'QUICKMODE_ORGUSERREGISTER_ROLE1'
											)}
										</TableCell>
										<TableCell
											className={
												this.props.classes
													.tabelCellColorFont
											}
										>
											{i18n.t(
												'QUICKMODE_ORGUSERREGISTER_ROLE2'
											)}
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{userList &&
										userList.length !== 0 &&
										userList.map((item, index) => (
											<TableRow
												style={{
													backgroundColor:
														(index as number) %
															2 ===
														0
															? '#cccccc'
															: '',
													borderBottom:
														'1px #d9d9d9 solid',
													borderTop:
														'1px #d9d9d9 solid',
												}}
											>
												<TableCell
													className={
														this.props.classes
															.tabelCellWidth
													}
												>
													{item.loginID}
												</TableCell>
												<TableCell
													className={
														this.props.classes
															.tabelCellWidth
													}
												>
													{item.familyName}
												</TableCell>
												<TableCell
													className={
														this.props.classes
															.tabelCellWidth
													}
												>
													{item.firstName}
												</TableCell>
												<TableCell
													className={
														this.props.classes
															.tabelCellWidth
													}
												>
													{item.addressMail}
												</TableCell>
												<TableCell
													className={
														this.props.classes
															.tabelCellWidth
													}
												>
													{item.role1}
												</TableCell>
												<TableCell>
													{item.role2}
												</TableCell>
											</TableRow>
										))}
								</TableBody>
							</Table>
						) : (
							''
						)}
					</div>
					{children &&
						children.length !== 0 &&
						children.map(
							(
								node: ISearchOrgUserItem,
								i: number
							): JSX.Element => (
								<Collapse
									key={i}
									in={this.state.openOrg}
									timeout="auto"
									unmountOnExit={true}
								>
									<QuickModeOrgUserRegisterTreeDetail
										classes={this.props.classes}
										searchOrgUserItemArry={node}
										width={width}
									/>
								</Collapse>
							),
							this
						)}
				</List>
			</div>
		);
	}

	public componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	}

	public handleResize() {
		const width = document.body.clientWidth - 75;
		this.setState({
			width,
		});
	}

	public componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	protected toggleTree = (e: any) => {
		this.setState({ openOrg: !this.state.openOrg });
	};
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export interface IMyProps {
	searchOrgUserItemArry: ISearchOrgUserItem;
	width?: number;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IMyProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeOrgUserRegisterTreeDetail);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/QuickModeOrgUserRegisterTreeDetail.tsx